<sh-json-formatter-renderer #jsonFormatterRenderer [params]="params"></sh-json-formatter-renderer>
